module.exports = __webpack_public_path__ + "static/media/khalti.926d5894.svg";